import { Theme } from '@mui/material'
import { SystemStyleObject } from '@mui/system'

export const styles: {
	button: Record<string, unknown>
	container: SystemStyleObject<Theme>
} = {
	button: {
		padding: 0,
	},
	container: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
		gap: '1.875rem',
	},
}

export default styles
